import { Card, Divider, Input, Tag } from 'antd'
import React, { useEffect, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Button } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { verifyDiscountCode } from 'api'
import { useMutation } from 'react-query'
import { subscriptionsActions } from 'store/reducers/subscriptions/subscriptions'
import ClearIcon from '@mui/icons-material/Clear'

const OrderForm = ({ showDiscount, onNavigate, login_res }) => {
  const isEmpty = (obj) => Object.keys(obj).length === 0;
  const { t } = useTranslation();
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const selectedPlan = useSelector((state) => state.subscriptions.plan) || JSON.parse(localStorage.getItem('plan'))
  const discountCode = useSelector((state) => state.subscriptions.discountCode)
  const token = useSelector((state) => state.subscriptions.registrationToken) || localStorage.getItem('registrationToken')
  const [code, setCode] = useState('')
  const [plan, setPlan] = useState(null)
  const [subscription, setSubscription] = useState(null)
  const [registrationToken, setRegistrationToken] = useState('')
  const [discount, setDiscount] = useState({})
  


  const [message, setMessage] = useState({
    type: '',
    message: ''
  })


  const verifyDiscount = useMutation({
    mutationKey: 'verify-discount-code',
    mutationFn: () => verifyDiscountCode(code, registrationToken),
    onSuccess: (res) => {

      setMessage({ type: 'success', message: 'Il codice coupon è stato inserito' })
      dispatch(subscriptionsActions.setDiscountCode({
        code: res?.resData?.data?.code,
        discount_value: res?.resData?.data?.discount_value
      }))
      localStorage.setItem('discount', JSON.stringify({
        code: res?.resData?.data?.code,
        discount_value: res?.resData?.data?.discount_value
      }))


      setDiscount({
        code: res?.resData?.data?.code,
        discount_value: res?.resData?.data?.discount_value
      })

      setCode('')

    },
    onError: (err) => {

      setMessage({ type: 'error', message: 'Il codice coupon inserito non è valido' })

    }
  })

  function calcIva(price, aliquota = 22) {
    return price * (aliquota / 100);
  }

  function calcDiscount(price) {
    if (discount?.discount_value) {
      return price * (discount?.discount_value / 100);
    } else {
      return 0
    }

  }

  //dopo 30 gg
  function calcNextCharge() {
    const today = new Date();
    const nextMonth = new Date();
    nextMonth.setMonth(today.getMonth() + 1);

    const options = { day: "2-digit", month: "short", year: "numeric" };
    return nextMonth.toLocaleDateString("it-IT", options);
  }

  //dopo 6gg
  function calcNextChargeTrial() {
    const today = new Date();
    const nextCharge = new Date();
    nextCharge.setDate(today.getDate() + 6);

    const options = { day: "2-digit", month: "short", year: "numeric" };
    return nextCharge.toLocaleDateString("it-IT", options);
  }


  useEffect(() => {
    if (login_res) {
      //console.log('login_res', login_res);

      if (login_res?.company?.subscription?.id !== 0) {
        setSubscription(login_res?.company?.subscription)
      } else {
        const temporary_data = JSON.parse(login_res?.temporary_data)
        // console.log('temporary_data', temporary_data);
        localStorage.setItem('plan', JSON.stringify(temporary_data?.selectedPlan))
        setPlan(temporary_data?.selectedPlan)
        setDiscount({
          code: temporary_data?.discountCode?.code,
          discount_value: temporary_data?.discountCode?.discount_value
        })



      }

    } else {
      if (!isEmpty(selectedPlan)) {
        setPlan(selectedPlan)
      } else {
        setPlan(JSON.parse(localStorage.getItem('plan')))
      }
    }


  }, [selectedPlan])

  useEffect(() => {

    if (token && token.length > 0) {
      localStorage.setItem('registrationToken', token)
      setRegistrationToken(token)
    } else {
      setRegistrationToken(localStorage.getItem('registrationToken'))
    }

  }, [token])


  useEffect(() => {
    if (discountCode) {
      setDiscount(discountCode)
    } else {
      setDiscount(JSON.parse(localStorage.getItem('discount')))
    }

  }, [discountCode])



  const monthlyPrice = plan?.type == 'year' ? plan?.tier?.price_per_seat_year : plan?.tier?.price_per_seat_month
  const monthlyPricePerSits = monthlyPrice * plan?.sits
  const subTotal = plan?.type == 'year' ? (monthlyPricePerSits * 12) : monthlyPricePerSits
  const applied_discount = plan?.type == 'year' ? calcDiscount(monthlyPricePerSits * 12) : calcDiscount(monthlyPricePerSits)
  const total = (calcIva(subTotal - applied_discount) + subTotal - applied_discount)


  const subMonthlyPrice = subscription?.amount_without_tax / subscription?.seat_number
  const subMonthlyPricePerSits = subscription?.amount_without_tax
  const subscriptionSubTotal = subscription?.amount_without_tax
  const sub_applied_discount = calcDiscount(subscriptionSubTotal)
  const sub_iva = calcIva(subscriptionSubTotal - sub_applied_discount)
  const subscriptionTotal = (subscriptionSubTotal - sub_applied_discount) + sub_iva

  return (
    <>


      <div className="w-full h-full  justify-left  p-[40px]" >
        <p className='text-3xl text-black font-semibold'>{t("Plans.MyOrderTitle")}</p>
        <p className='text-base text-[#828282] font-normal'>{t("Plans.MyOrderSubTitle")}</p>


        {plan && (<>
          <Card
            size="small"
            style={{ width: '100%', backgroundColor: '#EDEDEF', marginTop: '36px' }}>
            <div className='flex justify-between'>
              <p className='text-base font-normal text-black'> {plan?.type == 'year' ? t("Plans.Yearly") : t("Plans.Monthly")}</p>


              <p className='text-lg font-medium text-black'>
                {parseFloat(monthlyPrice).toFixed(2)}€ / mese/ user</p>
            </div>


            <p className='text-sm font-normal text-[#828282]'>{plan?.sits || 0} {t("Plans.Sits")}</p>
            <p className='text-sm font-normal text-[#828282]'>

              {t("Plans.Subscription")} {plan?.type == 'year' ? t("Plans.Yearly") : t("Plans.Monthly")} </p>



          </Card>

          {showDiscount && (
            <>
              <Divider />

              <div className='flex gap-4'>
                <Input
                  defaultValue={code}
                  value={code}
                  onChange={(e) => {
                    const val = e.target.value
                    setCode(val)
                  }} placeholder={`${t("Plans.Code")} ${t("Plans.Discount")}`} />



                <Button
                  onClick={() => { verifyDiscount.mutate() }}
                  type="button"
                  variant="outlined"
                  sx={{
                    borderColor: '#0049EE',
                    fontSize: '16px',
                    textTransform: 'none',
                    color: '#0049EE',
                    paddingLeft: '22px',
                    paddingRight: '22px',
                    fontWeight: 600
                  }}>
                  {t('Add')}
                </Button>
              </div>

              {discount?.code && discount?.discount_value && (
                <Tag style={{
                  backgroundColor: 'rgba(0, 73, 238, 0.10)',
                  borderRadius: 100,
                  color: '#0049EE',
                  fontSize: '14px',
                  fontWeight: 400,
                  marginTop: 4,
                  marginBottom: 4,

                }}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer'
                  }}
                    onClick={() => {
                      setDiscount({ code: '', discount_value: 0 })
                      localStorage.removeItem('discount')
                      setCode('')
                    }}
                  >
                    {discount?.code} {discount?.discount_value}%
                    <ClearIcon fontSize='20px' color='#0049EE' />
                  </div>

                </Tag>
              )}


              <p className={message?.type === 'error' ? `text-xs font-normal text-[#E53E3E]` : `text-xs font-normal text-green-900`} >{message?.message}</p>
            </>
          )}

          <Divider />

          <div>
            <div className='flex justify-between'>
              <p className='text-sm font-normal text-[#828282]'>Sub {t("Plans.Total")}</p>
              <p className='text-sm font-normal text-[#828282]'>{parseFloat(subTotal).toFixed(2)} €</p>
            </div>

            {applied_discount > 0 && (
               <div className='flex justify-between'>
               <p className='text-sm font-normal text-[#828282]'>{t('Plans.DiscountApplied')}</p>
               <p className='text-sm font-normal text-[#828282]'>- {parseFloat(applied_discount).toFixed(2)} €</p>
             </div>
            )}
           


            <div className='flex justify-between mt-2'>
              <p className='text-sm font-normal text-[#828282]'>IVA (22%)</p>
              <p className='text-sm font-normal text-[#828282]'>{parseFloat(calcIva(subTotal -applied_discount)).toFixed(2)} €</p>
            </div>

          </div>

          <Divider />

          <div>
            <div className='flex justify-between'>
              <p className='text-base font-medium text-black'> {t("Plans.Total")}</p>
              <p className='text-base font-medium text-black'>{parseFloat(total).toFixed(2)} €</p>


            </div>
            <p className='text-sm font-normal text-[#828282]'>{t("Plans.NextCharge")} {calcNextChargeTrial()}</p>
          </div>


          <p className='text-xs font-normal text-[#828282] mt-[20px]'>{t("Plans.InformationSubtitle", { price: parseFloat(monthlyPricePerSits).toFixed(2) })}


          </p>
        </>)}


        {subscription && subscription?.id !== 0 && (<>


          <Card
            size="small"
            style={{ width: '100%', backgroundColor: '#EDEDEF', marginTop: '36px' }}>
            <div className='flex justify-between'>
              <p className='text-base font-normal text-black'> {subscription?.payment_type == 'year' ? t("Plans.Yearly") : t("Plans.Monthly")}</p>


              <p className='text-lg font-medium text-black'>
                {parseFloat(subMonthlyPrice).toFixed(2)} € / mese/ user</p>
            </div>


            <p className='text-sm font-normal text-[#828282]'>{subscription?.seat_number || 0} {t("Plans.Sits")}</p>
            <p className='text-sm font-normal text-[#828282]'>

              {t("Plans.Subscription")} {subscription?.payment_type == 'year' ? t("Plans.Yearly") : t("Plans.Monthly")} </p>



          </Card>



          {showDiscount && (
            <>
              <Divider />

              <div className='flex gap-4'>
                <Input
                  defaultValue={discount?.code}
                  onChange={(e) => {
                    const val = e.target.value
                    setCode(val)
                  }} placeholder={`${t("Plans.Code")} ${t("Plans.Discount")}`} />



                <Button
                  onClick={() => { verifyDiscount.mutate() }}
              
                  type="button"
                  variant="outlined"
                  sx={{
                    borderColor: '#0049EE',
                    fontSize: '16px',
                    textTransform: 'none',
                    color: '#0049EE',
                    paddingLeft: '22px',
                    paddingRight: '22px',
                    fontWeight: 600
                  }}>
                  {t('Add')}
                </Button>
              </div>

              {discount?.code && discount?.discount_value && (
                <Tag style={{
                  backgroundColor: 'rgba(0, 73, 238, 0.10)',
                  borderRadius: 100,
                  color: '#0049EE',
                  fontSize: '14px',
                  fontWeight: 400,
                  marginTop: 4,
                  marginBottom: 4,

                }}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer'
                  }}
                       onClick={() => {
                         setDiscount({ code: '', discount_value: 0 })
                         localStorage.removeItem('discount')
                         setCode('')
                       }}
                  >
                    {discount?.code} {discount?.discount_value}%
                    <ClearIcon fontSize='20px' color='#0049EE' />
                  </div>

                </Tag>
              )}


              <p className={message?.type === 'error' ? `text-xs font-normal text-[#E53E3E]` : `text-xs font-normal text-green-900`} >{message?.message}</p>
              <Divider />
            </>
          )}

          <div>
            <div className='flex justify-between'>
              <p className='text-sm font-normal text-[#828282]'>Sub {t("Plans.Total")}</p>
              <p className='text-sm font-normal text-[#828282]'>{parseFloat(subscriptionSubTotal).toFixed(2)} €</p>
            </div>

            {sub_applied_discount > 0 && (
              <div className='flex justify-between'>
                <p className='text-sm font-normal text-[#828282]'>{t('Plans.DiscountApplied')}</p>
                <p className='text-sm font-normal text-[#828282]'>- {parseFloat(sub_applied_discount).toFixed(2)} €</p>
              </div>
            )}



            <div className='flex justify-between mt-2'>
              <p className='text-sm font-normal text-[#828282]'>IVA (22%) </p>
              <p className='text-sm font-normal text-[#828282]'>{parseFloat(sub_iva).toFixed(2)} €</p>
            </div>

          </div>

          <Divider />

          <div>
            <div className='flex justify-between'>
              <p className='text-base font-medium text-black'> {t("Plans.Total")}</p>
              <p className='text-base font-medium text-black'>{parseFloat(subscriptionTotal).toFixed(2)} €</p>


            </div>
            <p className='text-sm font-normal text-[#828282]'>{t("Plans.NextCharge")} {calcNextCharge()}</p>
          </div>
        </>)}



        <div className='mt-[80px]'>




          <p className='text-sm font-normal text-[#828282]'>
            <Trans i18nKey="Plans.AnnullSubscriptionText"
                   components={{

                     termsLink: <a className='text-sm font-normal text-[#1677FF]' rel="noreferrer" href="https://www.legalai.it/termini-condizioni"
                                   target="_blank" />,

                   }}
            />
          </p>
        </div>


      </div>
    </>
  )
}

export default OrderForm
